
export const CHAINSELECTORCONFIG_UPDATE_DATA = 'CHAINSELECTORCONFIG_UPDATE_DATA';


export const CHAINSELECTORCONFIG_CREATE = 'CHAINSELECTORCONFIG_CREATE';
export const CHAINSELECTORCONFIG_CREATE_SUCCESS = 'CHAINSELECTORCONFIG_CREATE_SUCCESS';
export const CHAINSELECTORCONFIG_CREATE_ERROR = 'CHAINSELECTORCONFIG_CREATE_ERROR';

export const CHAINSELECTORCONFIG_DELETE = 'CHAINSELECTORCONFIG_DELETE';
export const CHAINSELECTORCONFIG_DELETE_SUCCESS = 'CHAINSELECTORCONFIG_DELETE_ERROR';
export const CHAINSELECTORCONFIG_DELETE_ERROR = 'CHAINSELECTORCONFIG_DELETE_ERROR';

export const EDIT_CHAINSELECTORCONFIG = 'EDIT_CHAINSELECTORCONFIG';
export const EDIT_CHAINSELECTORCONFIG_SUCCESS = 'EDIT_CHAINSELECTORCONFIG_SUCCESS';
export const EDIT_CHAINSELECTORCONFIG_ERROR = 'EDIT_CHAINSELECTORCONFIG_ERROR';

export const CHAINSELECTORCONFIG_LIST = 'CHAINSELECTORCONFIG_LIST';
export const CHAINSELECTORCONFIG_SUCCESS = 'CHAINSELECTORCONFIG_SUCCESS';
export const CHAINSELECTORCONFIG_ERROR = 'CHAINSELECTORCONFIG_ERROR';

export const MULTIPLEMODEL_LIST = 'MULTIPLEMODEL_LIST';
export const MULTIPLEMODEL_LIST_SUCCESS = 'MULTIPLEMODEL_LIST_SUCCESS';
export const MULTIPLEMODEL_LIST_ERROR = 'MULTIPLEMODEL_LIST_ERROR';